<template>
    <div class="container">
        <div class="center">
            <div class="headline">
                <h1>GoCovid</h1>
                <h3>ร่วมฝ่าวิกฤตินี้ไปด้วยกัน</h3>
            </div>
            <div class="panal">
                <b-container>
                    <b-row>
                        <b-col>
                            <a href="https://forms.gle/BAv6u6ymNUprp2WF8" target="_blank">
                                <b-img class="img-icon" v-bind="mainProps" :src="require(`@/assets/minimask2.jpg`)"></b-img>
                            </a>
                            <h4><a style="color: #ff4599">Mini</a><a style="color: #0041c5">Mask</a></h4>
                            <h6>หน้ากากเด็ก ฟรี!</h6>
                        </b-col>
                        <b-col>
                            <a href="https://www.who.int/docs/default-source/searo/thailand/knowcovid-final-pages-r01.pdf" target="_blank">
                                <b-img class="img-icon" v-bind="mainProps" :src="require(`@/assets/knowcovid.jpg`)"></b-img>
                            </a>
                            <h4><a style="color: #bf1ebf">Know</a><a style="color: #2448c7">Covid</a></h4>
                            <h6>หนังสือขายหัวเราะฟรี</h6>
                        </b-col>
                        <b-col>
                            <b-img class="img-icon" @click="$router.push('ebook')" v-bind="mainProps" :src="require(`@/assets/corona.png`)"></b-img>
                            <h4><a style="color: #fe555a">I'm</a><a style="color: #4B78B0">Corona</a></h4>
                            <h6>นิทานโคโรนา</h6>
                        </b-col>

                        <b-col>
                            <b-img class="img-icon" @click="$router.push('gocovid')" v-bind="mainProps" :src="require(`@/assets/gocovid.jpg`)"></b-img>
                            <h4><a style="color: #ffc107">Covid</a><a style="color: #006ff9">Check</a></h4>
                            <h6>ค้นหาจุดตรวจใกล้ท่าน</h6>
                        </b-col>

                    </b-row>
                </b-container>
            </div>
        </div>
        <div class="right-bottom">
            <b-img height="120" :src="require(`@/assets/credit.png`)"></b-img>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Intro",
        data() {
            return {
                mainProps: {blankColor: '#777', height: 80, class: 'm1'},
            }
        }
    }
</script>

<style scoped>
    h4 {
        margin-top: 10px;
        font-weight: bold;
        font-size: 1em;
    }

    h6 {
        margin-top: -5px;
        font-size: 0.9em;
    }
    .img-icon {
        background-color: white;
        border-radius: 10px;
        margin-top: 10px;
    }
    .container {
        height: 100%;
        width: 100%;
        position: relative;
    }

    .center {
        padding: 10px;
        position: absolute;
        top: 50%;
        width: 90%;
        -ms-transform: translate(0%, -60%);
        transform: translate(0%, -60%);
    }

    .panal {
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 10px;
        margin-top: 15px;
    }

    .headline {
        color: white;
    }

    .right-bottom {
        text-align: right;
        position: absolute;
        bottom: -10px;
        right: 0px;
    }
</style>
